/* Every context the app runs inside, in one place.
   Split out of index.tsx so the entry file is only "mount the app" — the
   nesting and props are exactly what the entry file carried before. */

import React, { useEffect } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";

import { AuthProvider } from "@/features/auth";
import { createQueryClient } from "@/shared/api/queryClient";
import { initReloadOnNewBuild } from "@/shared/lib/new-build";

const queryClient = createQueryClient();

/* AuthProvider sits above the query client: it registers the bearer token into
   `shared/api/client.ts` during its own render, so it must be mounted before
   anything can fire a request. */
export function Providers({ children }: { children: React.ReactNode }) {
  // Here, not in index.tsx: it reads this client to see an upload or a send still running.
  useEffect(() => initReloadOnNewBuild(queryClient), []);
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
